import { StoreColourSetting } from 'Shared/backend/settingsPage/ColourSetting';
import { StyleFieldsRow } from 'Shared/backend/styles/StyleFieldsRow';


export function MenuTitleColour()
{
	return (
		<StyleFieldsRow>
			<MenuTitleColourFields />
		</StyleFieldsRow>
	);
}


/* The menu title colour on its own, for a caller that names the location itself - see
   ruleProperties(). It colours the section headings and item names at or below wherever the rule
   lands, so a whole menu takes it from the menu page and one kind of section takes it from that
   section's class. */
export function MenuTitleColourFields()
{
	return (
		<StoreColourSetting field='colour' label='' notes='' />
	);
}
